import {createSelector} from "reselect";
import {getAdminStoreState} from "../../store/admin-store-selectors";

export const getOrpyxUsersState = createSelector(getAdminStoreState, state => state.orpyxUsers);
